module.exports = __webpack_public_path__ + "img/file-chart-column.15b19d32.svg";